import type React from "react";
import { createContext, useContext, useState } from "react";
import type { Dispatch, SetStateAction } from "react";

export type Subscription = {
  id: string;
  plan: { type: string; amount?: number; [key: string]: unknown };
  current_period_end: number;
  current_period_start?: number;
  [key: string]: unknown;
};

type SubscriptionContextProps = {
  subscription: Subscription | null;
  step: string;
  setStep: Dispatch<SetStateAction<string>>;
  setSubscription: Dispatch<SetStateAction<Subscription | null>>;
};

const SubscriptionContext = createContext<SubscriptionContextProps | null>(null);

const SubscriptionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [step, setStep] = useState("Management");
  const [subscription, setSubscription] = useState<Subscription | null>(null);

  const contextValue = {
    subscription,
    step,
    setStep,
    setSubscription,
  };

  return (
    <SubscriptionContext.Provider value={contextValue}>{children}</SubscriptionContext.Provider>
  );
};

const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error("useSubscription must be used within a SubscriptionProvider");
  }
  return context;
};

export { SubscriptionProvider, useSubscription };
